var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineChartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2136 14.4275H1.57301V0.786485C1.57301 0.352108 1.22091 0 0.786504 0C0.352102 0 0 0.352093 0 0.786485V15.2135C0 15.6479 0.352102 16 0.786504 16H15.2135C15.6479 16 16 15.6479 16 15.2135C16 14.7791 15.648 14.4273 15.2135 14.4273L15.2136 14.4275Z",
    fill: "#A793F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44805 12.9357C3.54571 12.9793 3.64745 13 3.74778 13C4.03585 13 4.31031 12.8296 4.43341 12.5435L6.13768 8.58114L8.45153 10.2423C8.64096 10.3785 8.88124 10.4174 9.10245 10.3479C9.32391 10.2785 9.50111 10.1086 9.58249 9.88809L11.5894 4.45523L14.6627 2.3984C15.0078 2.16744 15.104 1.69521 14.877 1.34345C14.6502 0.991985 14.1865 0.894091 13.8411 1.12536L10.5645 3.31799C10.4321 3.40643 10.3309 3.53551 10.2751 3.6862L8.52294 8.42961L6.25068 6.79865C6.06701 6.66657 5.83474 6.6255 5.61876 6.68746C5.40235 6.74885 5.22473 6.90597 5.13465 7.11564L3.06291 11.9327C2.89737 12.3179 3.06979 12.7672 3.44808 12.9361L3.44805 12.9357Z",
    fill: "#A793F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartIcon);
export default __webpack_public_path__ + "static/media/line-chart-icon.d4cebd76551f90db62215451ea85977f.svg";
export { ForwardRef as ReactComponent };